import { useEffect } from 'react'
import { Box, Button, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import UploadRoundedIcon from '@mui/icons-material/UploadRounded'
import { ReactComponent as UploadSuccessful } from '../../../assets/etl/InProgress.svg'
import { ReactComponent as UploadFailed } from '../../../assets/error_404.svg'
import { useAppDispatch, useAppSelector } from '../../../store/hooks'
import { startNewEtl } from '../../../store/actions'
import FsContainer from '../common/Container'
import { formatDate } from '../../../shared/utils'

const FsAnalysisPreparation = () => {
  const dispatch = useAppDispatch()
  const { t, i18n } = useTranslation()
  const { latestEtlStatus } = useAppSelector((state) => state.currentEtl)
  const { runs } = useAppSelector((state) => state.currentAnalysis)
  const defaultLocale = i18n.language === 'en' ? 'en' : 'de'
  const correspondance = latestEtlStatus ? new Date(latestEtlStatus.dateEffective) : null
  const formattedCorrespondanceDate = correspondance
    ? formatDate(correspondance, defaultLocale, 'dd.mm.yyyy')
    : null

  const isSuccess = latestEtlStatus && latestEtlStatus.status && latestEtlStatus.step === 1
  const isAnalysisDone =
    runs &&
    latestEtlStatus &&
    runs.filter(
      (r) => formatDate(r.runAt, defaultLocale, 'dd.mm.yyyy') === formattedCorrespondanceDate,
    )

  const restart = () => dispatch(startNewEtl())

  useEffect(() => {
    if (isAnalysisDone && isAnalysisDone.length > 0) restart()
  }, [isAnalysisDone])

  return isSuccess ? (
    <FsContainer>
      <Typography mb={4}>
        {t('data.prepared', {
          date: formattedCorrespondanceDate,
          interpolation: { escapeValue: false },
        })}
      </Typography>
      <Stack alignItems="center">
        <UploadSuccessful />
        <Typography className="font-semibold" mt={2}>
          {t('new.date')}
        </Typography>
        <Button variant="contained" onClick={restart} sx={{ mt: 2 }}>
          {t('new.date.action')}
        </Button>
      </Stack>
    </FsContainer>
  ) : (
    <FsContainer>
      <Typography className="mb-2">
        {t('data.prepared.rejected', {
          date: formattedCorrespondanceDate,
          interpolation: { escapeValue: false },
        })}
      </Typography>
      <Box mb={4} mt={1} p={2} borderRadius={2} sx={{ backgroundColor: 'secondary.light' }}>
        <Typography component="div">
          <Typography className="font-semibold">{t('comment')}</Typography>
          <Typography>
            {latestEtlStatus?.reason
              ? latestEtlStatus?.reason
                  .split('||**||')
                  .map((s, i) =>
                    i === 0
                      ? s
                        ? `${t('reject.files', { files: s })}.`
                        : ''
                      : s
                      ? `${t('reject.reason', { reason: s })}.`
                      : '',
                  )
                  .join(' ')
              : ''}
          </Typography>
        </Typography>
      </Box>
      <Typography className="font-semibold" my={2}>
        {t('data.prepared.rejected.info')}
      </Typography>
      <Stack alignItems="center" width={500}>
        <UploadFailed height={220} />
        <Button
          variant="contained"
          onClick={restart}
          sx={{ mt: 2 }}
          startIcon={<UploadRoundedIcon />}
        >
          {t('data.prepared.rejected.action')}
        </Button>
      </Stack>
    </FsContainer>
  )
}

export default FsAnalysisPreparation
